import { Guid } from "guid-typescript";
import { IMessage } from "../../IMessage";

//Generated code, do not modify

export class UpdateActivityTypeCommand implements IMessage {
    id!: Guid;
    activityGroupId!: Guid;
    name!: string;
    filterable!: boolean;
    isDefaultSelected!: boolean;

    public constructor(init?: Partial<UpdateActivityTypeCommand>) {
        Object.assign(this, init);
    }

    getMethod = () => "PUT";

    getUrl = () => `/admin/activity-types/${this.id.toString()}`;

    getQueryString = () => undefined;

    getBody = () => {
        return {
            activityGroupId: this.activityGroupId,
            name: this.name,
            filterable: this.filterable,
            isDefaultSelected: this.isDefaultSelected,
        };
    }
}